import { FormattedMessage, injectIntl } from 'react-intl';
import { withRouter } from '~HOC';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FlightDetails } from '../../../../component';
import { numberWithCommas } from '../../../../utils/consts';
class FlightDetailCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDetail: false,
    };
  }
  getPassengerPriceByType(passengers, type, count) {
    let { totalPrice, baseFare, tax } = passengers.filter(
      (t) => t.type.toLowerCase() === type,
    ).length
      ? passengers.filter((t) => t.type.toLowerCase() === type)[0].price
      : { totalPrice: 0, baseFare: 0, tax: 0 };
    return { totalPrice, baseFare, tax, count };
  }
  // general function to show data of each column for flight
  renderColumn = (message, value, isNumber, centerClass) => {
    return (
      <div
        className={`d-flex flex-column text-uppercase font-weight-bold text-third font-smaller p-0 ${centerClass} `}
      >
        <div className="w-100 text-center">
          <FormattedMessage id={`booking.${message}`} />
        </div>

        <div className="w-100 text-uppercase font-small text-center font-weight-bold text-dark pt-2 justify-content-center d-flex">
          {isNumber ? numberWithCommas(value) : value}
        </div>
      </div>
    );
  };
  render() {
    let { selectFlight, passengers, totalPrice, currentFlight } = this.props;

    let flightType = selectFlight.flightType,
      adultPrice = this.getPassengerPriceByType(
        passengers,
        'adult',
        selectFlight.adultCount,
      ),
      childPrice = this.getPassengerPriceByType(
        passengers,
        'child',
        selectFlight.childCount,
      ),
      infantPrice = this.getPassengerPriceByType(
        passengers,
        'infant',
        selectFlight.infantCount,
      );

    let details = {
      ...selectFlight,
      adultPrice,
      childPrice,
      infantPrice,
      totalPrice,
    };
    return (
      <div className="d-flex w-100 justify-content-center flex-column">
        {selectFlight && selectFlight.itineraries && (
          <FlightDetails
            details={details}
            flightType={flightType.toLowerCase()}
            isModal={false}
            showPrice={false}
            flight={selectFlight}
            isBooking={true}
            tickets={currentFlight.tickets}
            currentFlight={currentFlight}
          />
        )}
      </div>
    );
  }
}
function mapStateToProps(state, props) {
  return {
    language: state.language,
    user: state?.user?.userInfo,
  };
}
export default injectIntl(
  connect(mapStateToProps, {})(withRouter(FlightDetailCard)),
);
